import axios from 'axios';
import { PUBLISHING_SERVICE_URL } from '~/config';
import { handleNetworkError, withVersionHeaders } from '../utilities/axiosUtilities';
import { removeIteratorKeyFromState } from '../utilities/browserUtilities';
import { getSolutionsById } from './solutionsService';
export function getSecurityReview(id) {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/streams/security_review/${id}`;
  return axios.get(url, withVersionHeaders('2')).then(response => {
    var _response$data;
    return (_response$data = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data !== void 0 ? _response$data : null;
  }).catch(handleNetworkError);
}
export function inheritPreviousVersionSecReview(id) {
  const url = `${PUBLISHING_SERVICE_URL}/security-review/inherit/${id}`;
  return axios.get(url, withVersionHeaders('2')).then(response => {
    var _response$data2;
    return (_response$data2 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data2 !== void 0 ? _response$data2 : null;
  }).catch(handleNetworkError);
}
export function upsertSecurityReview(securityReview) {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/streams/security_review`;
  // Clear iterator key before sending it to API
  const sanitizedSecurityReview = removeIteratorKeyFromState(JSON.parse(JSON.stringify(securityReview)));
  return axios.post(url, sanitizedSecurityReview, withVersionHeaders('2')).then(({
    data
  }) => data);
}
export function validateSecurityReview(securityReview) {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/streams/validate/security_review`;
  // Clear iterator key before sending it to API
  const sanitizedSecurityReview = removeIteratorKeyFromState(JSON.parse(JSON.stringify(securityReview)));
  return axios.post(url, sanitizedSecurityReview, withVersionHeaders('2')).then(({
    data
  }) => data).catch(handleNetworkError);
}
export function findSecurityReviewForPackageVersionId(id) {
  const url = `${PUBLISHING_SERVICE_URL}/security-review/package-version/${id}`;
  return axios.get(url, withVersionHeaders('2')).then(response => {
    var _response$data3;
    return (_response$data3 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data3 !== void 0 ? _response$data3 : null;
  }).catch(handleNetworkError);
}
export function getSecurityReviewReport(securityReviewStreamId) {
  const url = `${PUBLISHING_SERVICE_URL}/security-review/failure-report/${securityReviewStreamId}`;
  return axios.get(url, withVersionHeaders('2')).then(response => {
    var _response$data4;
    return (_response$data4 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data4 !== void 0 ? _response$data4 : null;
  });
}
export async function getIsReReview(solutionId) {
  var _withVersion$version;
  if (!solutionId) {
    return false;
  }
  const solutionInfo = await getSolutionsById(solutionId);
  const withVersion = solutionInfo === null || solutionInfo === void 0 ? void 0 : solutionInfo.solution;
  // We are currently checking if the securityBit is true
  if (withVersion !== null && withVersion !== void 0 && (_withVersion$version = withVersion.version) !== null && _withVersion$version !== void 0 && _withVersion$version.versionOptionsSecurityReviewed) {
    return true;
  }
  return false;
}